module.exports = __webpack_public_path__ + "img/Auto Dropped.17d9bf20.png";